const doc = [({"da":({"js":({"competitions_choose_team":({"or_create_your_own_team_and_invite_your_friends":"Opret et nyt hold, hvis du selv skal være holdkaptajn."})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;